// AboutSigmaStudio.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Think5WhysHelp.css';

const AboutSigmaStudio = () => {
  const topics = [
    {
      title: 'Overview of Think5Whys Sigma Studio',
      description: (
        <div>
          <p>
            Sigma Studio is a dedicated module designed to streamline Business Process Management (BPM) projects,
            catering specifically to Micro, Small, and Medium Enterprises (MSMEs) and small teams.
            Rooted in the DMAIC (Define, Measure, Analyze, Improve, Control) methodology for process improvement,
            Sigma Studio offers a lightweight framework equipped with essential tools selected
            from the vast array of Six Sigma resources.
          </p>
        </div>
      ),
    },
    {
      title: 'Sigma Studio Benefits',
      description: (
        <div>
          <p>
            <ul>
              <li><strong>Efficiency:</strong>
                Sigma Studio optimizes project management processes, fostering efficiency and reducing waste in BPM projects.</li>
              <li><strong>Adaptability:</strong>
                Designed for MSMEs and small teams, Sigma Studio adapts to the unique requirements and
                constraints of smaller-scale projects.</li>
              <li><strong>Focus:</strong>
                By offering a focused set of tools, Sigma Studio ensures teams can stay on track and prioritize efforts effectively.</li>
              <li><strong>Continuous Improvement:</strong>
                Through its adherence to the DMAIC methodology, Sigma Studio promotes a culture of
                continuous improvement, driving sustained success in process optimization endeavors.</li>
            </ul>
          </p>
        </div>
      ),
    },
    {
      title: 'Sigma Studio Features',
      description: (
        <div>
          <p>
            <p><strong>Key Features:</strong></p>
            <ul>
              <li><strong>DMAIC Methodology:</strong>
                Sigma Studio guides projects through the DMAIC methodology, providing a structured approach to
                process improvement initiatives.</li>
              <li><strong>Small Team Focus:</strong>
                Tailored for MSMEs and small teams, Sigma Studio offers a compact yet powerful suite of tools,
                optimizing efficiency and resource utilization.</li>
              <li><strong>Tool Selection:</strong>
                Sigma Studio curates a small set of tools from the extensive Six Sigma toolbox, ensuring relevance
                and applicability to the project's scope and scale.</li>
              <li><strong>Process Streamlining:</strong>
                By facilitating the Define, Measure, Analyze, Improve, and Control phases, Sigma Studio empowers
                teams to streamline processes, enhance productivity, and drive continuous improvement.</li>
              <li><strong>Lightweight Framework:</strong>
                With its lightweight design, Sigma Studio minimizes complexity and overhead, enabling quick deployment
                and seamless integration into existing workflows.</li>
            </ul>
          </p>
        </div>
      ),
    },
    {
      title: 'Managing the 5 Phases with Sigma Studio',
      description: (
        <div>
          <p><strong>Managing the 5 Phases of DMAIC with Sigma Studio:</strong></p>

          <p><strong>1. Define:</strong></p>
          <p>Sigma Studio provides tools to clearly define project goals, scope, and stakeholders. 
           techniques such as Project Charters and Voice of the Customer (VoC) analysis, teams can establish 
           a solid foundation for the project.</p>

          <p><strong>2. Measure:</strong></p>
          <p>For the measurement phase, Sigma Studio offers tools for data collection and process mapping. 
           tools like Process Flowcharts and Data Collection Plans, teams can accurately measure process performance and 
           identify key metrics for improvement.</p>

          <p><strong>3. Analyze:</strong></p>
          <p>In the analysis phase, Sigma Studio assists teams in identifying root causes of process inefficiencies. 
          Tools such as Fishbone Diagrams (Ishikawa) and Pareto Analysis enable teams to prioritize issues and 
          delve deep into underlying causes.</p>

          <p><strong>4. Improve:</strong></p>
          <p>Sigma Studio facilitates the improvement phase by providing tools for generating and implementing solutions. 
          Utilizing methods like Brainstorming and Failure Mode and Effects Analysis (FMEA), 
          teams can develop actionable solutions to address identified issues and enhance process performance.</p>

          <p><strong>5. Control:</strong></p>
          <p>During the control phase, Sigma Studio supports teams in sustaining process improvements. 
          Through tools like Control Charts and Standard Operating Procedures (SOPs), teams can monitor process stability and establish protocols to ensure long-term success and prevent regression.</p>

          <p>By providing a curated selection of tools tailored to each phase of the DMAIC methodology, 
          Sigma Studio empowers teams to navigate through process improvement projects with clarity, efficiency, and effectiveness.</p>

        </div>
      ),
    },
    {
      title: 'Managing the 5 Phases with Sigma Studio',
      description: (
        <div>
          <p><strong>Managing the 5 Phases of DMAIC with Sigma Studio:</strong></p>

          <p><strong>1. Define:</strong></p>
          <p>Sigma Studio provides tools to clearly define project goals, scope, and stakeholders. 
           techniques such as Project Charters and Voice of the Customer (VoC) analysis, teams can establish 
           a solid foundation for the project.</p>

          <p><strong>2. Measure:</strong></p>
          <p>For the measurement phase, Sigma Studio offers tools for data collection and process mapping. 
           tools like Process Flowcharts and Data Collection Plans, teams can accurately measure process performance and 
           identify key metrics for improvement.</p>

          <p><strong>3. Analyze:</strong></p>
          <p>In the analysis phase, Sigma Studio assists teams in identifying root causes of process inefficiencies. 
          Tools such as Fishbone Diagrams (Ishikawa) and Pareto Analysis enable teams to prioritize issues and 
          delve deep into underlying causes.</p>

          <p><strong>4. Improve:</strong></p>
          <p>Sigma Studio facilitates the improvement phase by providing tools for generating and implementing solutions. 
          Utilizing methods like Brainstorming and Failure Mode and Effects Analysis (FMEA), 
          teams can develop actionable solutions to address identified issues and enhance process performance.</p>

          <p><strong>5. Control:</strong></p>
          <p>During the control phase, Sigma Studio supports teams in sustaining process improvements. 
          Through tools like Control Charts and Standard Operating Procedures (SOPs), teams can monitor process stability and establish protocols to ensure long-term success and prevent regression.</p>

          <p>By providing a curated selection of tools tailored to each phase of the DMAIC methodology, 
          Sigma Studio empowers teams to navigate through process improvement projects with clarity, efficiency, and effectiveness.</p>

        </div>
      ),
    },  
    {
      title: 'Sigma Studio Tools',
      description: (
        <div>
           <p>Sigma Studio evolves iteratively, incorporating user feedback to enhance usability and functionality 
          over time while maintaining simplicity for MSMEs and individuals. As more tools are integrated, 
           Studio remains committed to providing a user-friendly tech platform for end-to-end process improvement projects.</p>

          <p><strong>SIPOC (Supplier, Input, Process, Output, Customer):</strong> 
          Sigma Studio streamlines process understanding by mapping out key elements from suppliers to customers, 
          ensuring a comprehensive view of the process landscape.</p>

          <p><strong>Pareto Chart:</strong> 
          Utilizing Pareto Charts, Sigma Studio enables teams to prioritize improvement efforts by identifying 
          and addressing the most significant issues contributing to process inefficiencies.</p>

          <p><strong>5S (Sort, Set in order, Shine, Standardize, Sustain):</strong> 
          Sigma Studio promotes workplace organization and efficiency through the implementation of 5S principles, 
          fostering a culture of cleanliness, orderliness, and standardization.</p>

          <p><strong>Kanban:</strong> 
          By visualizing workflow and limiting work in progress, Sigma Studio enhances productivity and 
          efficiency through the implementation of Kanban boards, ensuring smooth and streamlined process execution.</p>

          <p><strong>5 Whys:</strong> 
          Sigma Studio facilitates root cause analysis by guiding users through the iterative process of 
          asking "why" to uncover underlying issues and drive meaningful improvements within the process.</p>

          <p><strong>Fishbone Diagram:</strong> 
          Through the Fishbone Diagram, Sigma Studio assists teams in identifying potential causes of 
          process variation, enabling targeted problem-solving and decision-making.</p>

          <p><strong>Process Map:</strong> 
          Sigma Studio provides a visual representation of process flows and dependencies, facilitating 
          process understanding and identifying opportunities for optimization and streamlining.</p>

          <p><strong>Kaizen:</strong> 
          Encouraging continuous improvement, Sigma Studio promotes the implementation of Kaizen principles, 
          empowering teams to make incremental changes for enhanced process efficiency and effectiveness.</p>

          <p><strong>Poka-yoke:</strong> 
          Sigma Studio integrates error-proofing techniques to prevent defects and errors in processes,
           ensuring quality and reliability in the final output.</p>

          <p><strong>RACI Matrix (Responsible, Accountable, Consulted, Informed):</strong> 
          Sigma Studio introduces the RACI Matrix to clarify roles and responsibilities within process improvement projects, 
          promoting accountability and effective collaboration.</p>
        </div>
      ),
    },  
    {
      title: 'Sigma Studio As a Tool for Process Improvement Project',
      description: (
        <div>
           <p>Sigma Studio evolves iteratively, incorporating user feedback to enhance usability and functionality 
          over time while maintaining simplicity for MSMEs and individuals. As more tools are integrated, 
           Studio remains committed to providing a user-friendly tech platform for end-to-end process improvement projects.</p>

          <p><strong>SIPOC (Supplier, Input, Process, Output, Customer):</strong> 
          Sigma Studio streamlines process understanding by mapping out key elements from suppliers to customers, 
          ensuring a comprehensive view of the process landscape.</p>

          <p><strong>Pareto Chart:</strong> 
          Utilizing Pareto Charts, Sigma Studio enables teams to prioritize improvement efforts by identifying 
          and addressing the most significant issues contributing to process inefficiencies.</p>

          <p><strong>5S (Sort, Set in order, Shine, Standardize, Sustain):</strong> 
          Sigma Studio promotes workplace organization and efficiency through the implementation of 5S principles, 
          fostering a culture of cleanliness, orderliness, and standardization.</p>

          <p><strong>Kanban:</strong> 
          By visualizing workflow and limiting work in progress, Sigma Studio enhances productivity and 
          efficiency through the implementation of Kanban boards, ensuring smooth and streamlined process execution.</p>

          <p><strong>5 Whys:</strong> 
          Sigma Studio facilitates root cause analysis by guiding users through the iterative process of 
          asking "why" to uncover underlying issues and drive meaningful improvements within the process.</p>

          <p><strong>Fishbone Diagram:</strong> 
          Through the Fishbone Diagram, Sigma Studio assists teams in identifying potential causes of 
          process variation, enabling targeted problem-solving and decision-making.</p>

          <p><strong>Process Map:</strong> 
          Sigma Studio provides a visual representation of process flows and dependencies, facilitating 
          process understanding and identifying opportunities for optimization and streamlining.</p>

          <p><strong>Kaizen:</strong> 
          Encouraging continuous improvement, Sigma Studio promotes the implementation of Kaizen principles, 
          empowering teams to make incremental changes for enhanced process efficiency and effectiveness.</p>

          <p><strong>Poka-yoke:</strong> 
          Sigma Studio integrates error-proofing techniques to prevent defects and errors in processes,
           ensuring quality and reliability in the final output.</p>

          <p><strong>RACI Matrix (Responsible, Accountable, Consulted, Informed):</strong> 
          Sigma Studio introduces the RACI Matrix to clarify roles and responsibilities within process improvement projects, 
          promoting accountability and effective collaboration.</p>
        </div>
      ),
    },    
  ];

  const [expandedTopic, setExpandedTopic] = useState(null);

  const handleTopicClick = (index) => {
    setExpandedTopic(expandedTopic === index ? null : index);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>About Sigma Studio</h2>
      </div>
      <div className="help-container">
        <ul className="help-list">
          {topics.map((topic, index) => (
            <li key={index} onClick={() => handleTopicClick(index)} className="help-topic">
              {topic.title}
              {expandedTopic === index && (
                <div className="help-description">
                  <p>{topic.description}</p>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </MainLayout>
  );
};

export default AboutSigmaStudio;


